var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 242.449,
    height: 29.598,
    viewBox: "0 0 242.449 29.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SINDION",
    transform: "translate(-350.77 -542.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6142",
    "data-name": "Path 6142",
    d: "M350.77,561.59V551.25h3.871a3.023,3.023,0,1,1,0,6.044h-2.989v4.3h-.882Zm6.076-7.318a2.135,2.135,0,0,0-2.287-2.221h-2.908v4.427h2.908A2.123,2.123,0,0,0,356.846,554.272Z",
    transform: "translate(0 5.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6143",
    "data-name": "Path 6143",
    d: "M356.87,556.8a3.608,3.608,0,1,1,3.577,3.936A3.615,3.615,0,0,1,356.87,556.8Zm6.321,0c0-1.666-.98-3.2-2.744-3.2-1.731,0-2.728,1.535-2.728,3.2,0,1.682,1,3.218,2.728,3.218C362.228,560.018,363.191,558.483,363.191,556.8Z",
    transform: "translate(3.864 6.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6144",
    "data-name": "Path 6144",
    d: "M370.3,560.481l-2.091-6.4-2.107,6.4h-.768L362.9,553h.866l1.993,6.354L367.866,553h.7l2.107,6.354L372.668,553h.866l-2.434,7.481Z",
    transform: "translate(7.684 6.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6145",
    "data-name": "Path 6145",
    d: "M371.02,556.8a3.706,3.706,0,0,1,3.594-3.92c2.287,0,3.528,1.8,3.528,3.969v.212h-6.272a2.911,2.911,0,0,0,2.924,2.973,3.283,3.283,0,0,0,2.45-1.045l.425.523a3.885,3.885,0,0,1-2.924,1.209A3.657,3.657,0,0,1,371.02,556.8Zm3.577-3.218a2.824,2.824,0,0,0-2.711,2.858h5.439A2.747,2.747,0,0,0,374.6,553.582Z",
    transform: "translate(12.827 6.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6146",
    "data-name": "Path 6146",
    d: "M377.61,560.538v-7.481h.8v1.29a3.224,3.224,0,0,1,2.532-1.437v.882a1.658,1.658,0,0,0-.408-.033,2.842,2.842,0,0,0-2.123,1.339v5.456h-.8Z",
    transform: "translate(17.001 6.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6147",
    "data-name": "Path 6147",
    d: "M381.31,556.8a3.706,3.706,0,0,1,3.594-3.92c2.287,0,3.528,1.8,3.528,3.969v.212h-6.272a2.911,2.911,0,0,0,2.924,2.973,3.283,3.283,0,0,0,2.45-1.045l.425.523a3.885,3.885,0,0,1-2.924,1.209A3.656,3.656,0,0,1,381.31,556.8Zm3.594-3.218a2.824,2.824,0,0,0-2.711,2.858h5.439A2.747,2.747,0,0,0,384.9,553.582Z",
    transform: "translate(19.345 6.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6148",
    "data-name": "Path 6148",
    d: "M393.579,561.6V560.4a3.19,3.19,0,0,1-2.6,1.372c-1.993,0-3.332-1.519-3.332-3.92,0-2.368,1.356-3.936,3.332-3.936a3.155,3.155,0,0,1,2.6,1.388V551.24h.817v10.34h-.817Zm0-1.878V556.01a2.984,2.984,0,0,0-2.466-1.372c-1.666,0-2.614,1.388-2.614,3.2s.964,3.2,2.614,3.2A2.922,2.922,0,0,0,393.579,559.717Z",
    transform: "translate(23.361 5.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6149",
    "data-name": "Path 6149",
    d: "M397.69,561.59V551.25h.8v4.067a3.2,3.2,0,0,1,2.6-1.388c1.993,0,3.348,1.568,3.348,3.937,0,2.4-1.372,3.92-3.348,3.92a3.19,3.19,0,0,1-2.6-1.372v1.192h-.8Zm3.267-.539c1.682,0,2.614-1.388,2.614-3.2s-.947-3.2-2.614-3.2a3.048,3.048,0,0,0-2.466,1.372v3.708A3.049,3.049,0,0,0,400.957,561.05Z",
    transform: "translate(29.72 5.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6150",
    "data-name": "Path 6150",
    d: "M404.15,562.67a1.724,1.724,0,0,0,.653.131c.49,0,.833-.2,1.143-.915l.588-1.339L403.35,553h.9l2.728,6.55,2.7-6.55h.915l-3.871,9.131a1.986,1.986,0,0,1-1.911,1.388,2.959,2.959,0,0,1-.8-.114Z",
    transform: "translate(33.306 6.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6151",
    "data-name": "Path 6151",
    d: "M430.84,560.666l.784-1a4.287,4.287,0,0,0,3.234,1.486c1.846,0,2.434-1,2.434-1.8,0-2.663-6.125-1.176-6.125-4.868,0-1.7,1.519-2.891,3.561-2.891a4.85,4.85,0,0,1,3.659,1.454l-.768.947a3.9,3.9,0,0,0-2.989-1.241c-1.225,0-2.123.67-2.123,1.65,0,2.319,6.125,1,6.125,4.851,0,1.486-1.029,3.038-3.822,3.038A5.156,5.156,0,0,1,430.84,560.666Z",
    transform: "translate(50.719 5.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6152",
    "data-name": "Path 6152",
    d: "M437.74,562.05V551.71h1.29v10.34Z",
    transform: "translate(55.089 5.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6153",
    "data-name": "Path 6153",
    d: "M448.278,562.05,442.25,553.8v8.249h-1.29V551.71h1.323l5.962,8.085V551.71h1.29v10.34Z",
    transform: "translate(57.129 5.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6154",
    "data-name": "Path 6154",
    d: "M448.63,562.05V551.71h3.528a5.172,5.172,0,1,1,0,10.339H448.63Zm7.5-5.162a3.778,3.778,0,0,0-3.969-4.035H449.9v8.053h2.254A3.8,3.8,0,0,0,456.127,556.888Z",
    transform: "translate(61.987 5.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6155",
    "data-name": "Path 6155",
    d: "M456.23,562.05V551.71h1.29v10.34Z",
    transform: "translate(66.801 5.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6156",
    "data-name": "Path 6156",
    d: "M459.19,556.958a5.141,5.141,0,1,1,5.129,5.341A5.055,5.055,0,0,1,459.19,556.958Zm8.951,0c0-2.417-1.5-4.2-3.822-4.2s-3.806,1.781-3.806,4.2c0,2.4,1.47,4.2,3.806,4.2C466.638,561.156,468.141,559.359,468.141,556.958Z",
    transform: "translate(68.676 5.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6157",
    "data-name": "Path 6157",
    d: "M474.978,562.05,468.95,553.8v8.249h-1.29V551.71h1.323l5.962,8.085V551.71h1.29v10.34Z",
    transform: "translate(74.041 5.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6158",
    "data-name": "Path 6158",
    d: "M478.64,562.05V551.71h1.29v9.2h4.8v1.143Z",
    transform: "translate(80.996 5.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6159",
    "data-name": "Path 6159",
    d: "M487.207,562.05v-9.2H483.94V551.71h7.84v1.143H488.5v9.2Z",
    transform: "translate(84.353 5.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6160",
    "data-name": "Path 6160",
    d: "M490.74,562.05V551.71h3.528a5.172,5.172,0,1,1,0,10.339H490.74Zm7.5-5.162a3.778,3.778,0,0,0-3.969-4.035h-2.254v8.053h2.254A3.8,3.8,0,0,0,498.237,556.888Z",
    transform: "translate(88.661 5.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6161",
    "data-name": "Path 6161",
    d: "M498.16,557.939a.865.865,0,0,1,.849-.849.849.849,0,1,1-.849.849Z",
    transform: "translate(93.361 9.064)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1831",
    "data-name": "Group 1831",
    transform: "translate(450.605 542.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6162",
    "data-name": "Path 6162",
    d: "M428.535,563.291l-3.822,2.189-6.4-3.692-6.419-3.708v-4.41Z",
    transform: "translate(-411.89 -535.882)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6163",
    "data-name": "Path 6163",
    d: "M435.64,563.628l-23.75-13.7v-2.189l1.895-1.094,23.75,13.721v2.172Z",
    transform: "translate(-411.89 -540.335)",
    fill: "#00a5b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6164",
    "data-name": "Path 6164",
    d: "M430.746,556.614,414.02,546.96l2.94-1.7,1-.572,12.79,7.383Z",
    transform: "translate(-410.541 -541.57)",
    fill: "#00a5b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6165",
    "data-name": "Path 6165",
    d: "M417.4,544.985l3.822-2.205,6.419,3.691,6.4,3.708v4.41Z",
    transform: "translate(-408.4 -542.78)",
    fill: "#00a5b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6166",
    "data-name": "Path 6166",
    d: "M415.23,551.69l16.71,9.654-2.924,1.7-1.013.572-12.773-7.383Z",
    transform: "translate(-409.774 -537.136)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowered);
export default __webpack_public_path__ + "static/media/powered.5f4d16f4cbc447e49c97341e105f9fe2.svg";
export { ForwardRef as ReactComponent };